import { Component, Input, Optional, Self } from '@angular/core';
import { ControlBase } from '../base/control.base';
import { NgControl } from '@angular/forms';
import { SelectedItem } from '../models/selected-item.interface';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cec-select',
  standalone: true,
  imports: [MatFormFieldModule, MatLabel, MatSelectModule, TranslateModule],
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss', '../shared/input.styles.scss']
})
export class SelectComponent extends ControlBase<number> {

  @Input() protected options: SelectedItem[] = [];

  @Input() public fillSpace = true;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    super(ngControl);
  }
  
  protected getControlValue(): number {
    return this.value;
  }

  protected setControlValue(val: number): void {
    if (!val) {
      return null;
    }

    this.value = val;
  }

  protected setControlDisabled(isDisable: boolean): void {
    this.isDisabled.set(isDisable);
  }

  protected onSelectChange(event: MatSelectChange): void {
    this.ngControl?.control?.setValue(event.value);
  }

  /** @inheritdoc */
  protected override afterValueWrite(): void {
    this.ngControl?.control?.updateValueAndValidity();
  }

}
